import VirtualizedList from '~/components/VirtualizedList';
import { PRODUCT_TYPE_E_COUPON } from '~/domains/e-coupon/constants';
import FrequentlyOrderedProductCard from '~/pages/app/components/MarketHomeFrequently/FrequentlyOrderedProductCard';
import type { OAISchema } from '~/types/openapi';
import { chunk } from '~/utils/array';

import ECouponProductCard from '../ECouponProductCard';

import styles from './index.module.css';

type Props = {
  data: OAISchema['MarketSelectProductResponseV2'][];
};

const ProductDisplayFrequentlyOrdered = ({ data }: Props) => {
  const chunked = chunk(data, 2);
  return (
    <div className="px-20">
      <VirtualizedList
        data={chunked}
        defaultItemHeight={130}
        initialItemCount={
          chunked.length > 1 ? chunked.length - 1 : chunked.length
        }
        itemContent={(rowIndex, rowData) => (
          <>
            <div className={styles.container}>
              {rowData.map((item) => {
                if (item.productType === PRODUCT_TYPE_E_COUPON) {
                  return (
                    <ECouponProductCard
                      key={item.offerId}
                      {...item}
                      eventOption={{ detailedPlaceMent: '자주구매한상품' }}
                      reverseCouponDiscountedPrice
                      useOrderCount
                    />
                  );
                }
                return (
                  <FrequentlyOrderedProductCard
                    key={item.offerId}
                    {...item}
                    eventOption={{ detailedPlaceMent: '자주구매한상품' }}
                    reverseCouponDiscountedPrice
                  />
                );
              })}
            </div>
            {rowIndex < chunked.length - 1 && <div className="h-24" />}
          </>
        )}
      />
    </div>
  );
};

export default ProductDisplayFrequentlyOrdered;
